if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;

      // Si falta viewer o thumbnails, no hacemos nada
      if (!this.elements.viewer || !this.elements.thumbnails) return;

      // Evento al cambiar de slide (por slider)
      this.elements.viewer.addEventListener(
        'slideChanged',
        debounce(this.onSlideChanged.bind(this), 500)
      );

      // ✅ Listener robusto para TODAS las miniaturas (clic en li o en el botón)
      this.elements.thumbnails.addEventListener('click', (event) => {
        const thumbItem = event.target.closest('[data-target]');
        if (!thumbItem) return;

        const mediaId = thumbItem.dataset.target;
        if (!mediaId) return;

        this.setActiveMedia(mediaId, false);
      });

      // Layout desktop con miniaturas
      if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      if (!event || !event.detail || !event.detail.currentElement) return;

      const mediaId = event.detail.currentElement.dataset.mediaId;
      if (!mediaId || !this.elements.thumbnails) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend = false, filtering = false, currentVariant = null) {
      if (!mediaId || !this.elements.viewer) return;

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return; // si no encuentra la imagen, no rompemos nada

      // Quitar activo de todos
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      // Reordenar (si está activado)
      if (prepend && this.prependMedia) {
        if (activeMedia.parentElement) {
          activeMedia.parentElement.prepend(activeMedia);
        }

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail && activeThumbnail.parentElement) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }

        if (this.elements.viewer.slider && typeof this.elements.viewer.resetPages === 'function') {
          this.elements.viewer.resetPages();
        }
      }

      // Filtrado por variante (si aplica)
      if (filtering && currentVariant && this.filteringOption) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item');
        allSlides.forEach((slide) => {
          if (slide.dataset.alt === currentVariant[this.filteringOption]) {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });
      }

      this.preventStickyHeader();

      // Scroll al media activo
      window.setTimeout(() => {
        if (this.elements.thumbnails && activeMedia.parentElement) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }

        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;

      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) {
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      // reset aria-current
      this.elements.thumbnails.querySelectorAll('button').forEach((element) =>
        element.removeAttribute('aria-current')
      );

      const btn = thumbnail.querySelector('button');
      if (btn) {
        btn.setAttribute('aria-current', 'true');
      }

      // Si no hay slider o función isSlideVisible, no intentamos nada más
      if (!this.elements.thumbnails.slider ||
          typeof this.elements.thumbnails.isSlideVisible !== 'function') {
        return;
      }

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      if (!this.elements.liveRegion || !activeItem) return;

      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;

      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'true');
        }, 2000);
      };

      // Forzar onload aunque ya esté cargada
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      if (!activeItem) return;
      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;

      this.elements.viewer.slider.setAttribute('role', 'presentation');
      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  });
}
